import { Component, OnInit } from "@angular/core";
import { AutologoutService } from "src/app/core/service/autologout.service";

@Component({
  selector: "app-main-layout",
  templateUrl: "./main-layout.component.html",
  styleUrls: [],
})
export class MainLayoutComponent implements OnInit {
  constructor(private autoLogoutService: AutologoutService) {}

  ngOnInit(): void {
    this.autoLogoutService.StartTimer();
    this.autoLogoutService.OnTimerOut();
  }
}
